/**
 * The identify function does nothing but return it's own argument
 * @memberOf identity
 * @argument {function} d Argument to return
 */
function identity (d) {
  return d
}

export default identity
